/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import 'reflect-metadata';
import constants from '../constants';
/**
 * Decorator: Specifies a custom registration strategy for the decorated class/function.
 */
export function Registration(value) {
    return (target) => {
        Reflect.defineMetadata(constants.registration, value, target);
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnaXN0cmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVnaXN0cmF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7OztHQUtHO0FBQ0gsT0FBTyxrQkFBa0IsQ0FBQztBQUMxQixPQUFPLFNBQVMsTUFBTSxjQUFjLENBQUM7QUFHckM7O0dBRUc7QUFDSCxNQUFNLFVBQVUsWUFBWSxDQUFDLEtBQXlCO0lBQ2xELE9BQU8sQ0FBQyxNQUFXLEVBQUUsRUFBRTtRQUNuQixPQUFPLENBQUMsY0FBYyxDQUFDLFNBQVMsQ0FBQyxZQUFZLEVBQUUsS0FBSyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ2xFLENBQUMsQ0FBQztBQUNOLENBQUMifQ==